module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "toc-ttl",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Table of contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c4#title"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c5#copy"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx2",
    attrs: {
      "id": "int1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c9#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c10#ch1"
    }
  }, [_vm._v("Jazz and the White Critic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c11#ch2"
    }
  }, [_vm._v("Minton’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c12#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dark Lady of the Sonnets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c13#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recent Monk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c14#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Ways to Play the Saxophone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c15#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Day With Roy Haynes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c16#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sonny Rollins "), _c('i', [_vm._v("(Our Man in Jazz)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c17#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Jazz Great: John Coltrane")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx2",
    attrs: {
      "id": "toc9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c18#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coltrane Live at Birdland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c19#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Jazz Avant-Garde")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c20#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introducing Wayne Shorter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c21#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introducing Dennis Charles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c22#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York Loft and Coffee Shop Jazz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c23#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introducing Bobby Bradford")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c24#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Present Perfect (Cecil Taylor)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c25#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cecil Taylor "), _c('i', [_vm._v("(The World of Cecil Taylor)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c26#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cores #1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c27#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cores #2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c28#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cores #3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c29#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cores #4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c30#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cores #5—The Burton Greene Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c31#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cores #6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c32#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Tenor Archie Shepp Talking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c33#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four for Trane (Archie Shepp)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c34#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don Cherry")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1",
    attrs: {
      "id": "toc26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c35#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Black Music: A Concert in Benefit of The Black Arts Repertory Theatre/School Live")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c36#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sonny’s Time Now")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx2",
    attrs: {
      "id": "toc28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c37#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Changing Same (R&B and New Black Music)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx2",
    attrs: {
      "id": "brief1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c38#brief",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Brief Discography of New Music")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "toc29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c39#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interview with Amiri Baraka by Calvin Reid (2009)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 78
// module chunks = 0